import * as React from "react";
import type { SVGProps } from "react";
const SvgUsersProfilesX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M1.4 21.6a1 1 0 0 0 2 0h-2m1-3.6h1zm10.8-2.6a1 1 0 1 0 0-2v2m7.693 2.707a1 1 0 0 0 1.414-1.414l-.707.707zm-2.404-5.232a1 1 0 0 0-1.415 1.414l.707-.707zm-1.415 3.818a1 1 0 0 0 1.415 1.414l-.707-.707zm5.233-2.404a1 1 0 0 0-1.414-1.415l.707.707zM14.4 6h-1a2.6 2.6 0 0 1-2.6 2.6v2A4.6 4.6 0 0 0 15.4 6zm-3.6 3.6v-1A2.6 2.6 0 0 1 8.2 6h-2a4.6 4.6 0 0 0 4.6 4.6zM7.2 6h1a2.6 2.6 0 0 1 2.6-2.6v-2A4.6 4.6 0 0 0 6.2 6zm3.6-3.6v1A2.6 2.6 0 0 1 13.4 6h2a4.6 4.6 0 0 0-4.6-4.6zM2.4 21.6h1V18h-2v3.6zM6 14.4v-1A4.6 4.6 0 0 0 1.4 18h2A2.6 2.6 0 0 1 6 15.4zm0 0v1h7.2v-2H6zm15.6 3 .707-.707-1.91-1.91-.706.708-.707.707 1.909 1.91zm-1.91-1.91.708-.706-1.91-1.91-.706.708-.708.707 1.91 1.909zm-1.908 1.91.707.707 1.909-1.91-.707-.706-.707-.707-1.91 1.909zm1.909-1.91.707.708 1.91-1.91-.708-.707-.707-.707-1.91 1.91z"
    />
  </svg>
);
export default SvgUsersProfilesX;
